const { useEffect, useState } = require('react')

export function useIsFullyInViewport(ref) {
  const [isFullyInViewport, setIsFullyInViewport] = useState(true)

  useEffect(() => {
    const observer = new ResizeObserver(([entry]) => {
      const [{ blockSize }] = entry?.borderBoxSize ?? []
      const { top } = ref.current.getBoundingClientRect() ?? {}
      if (top + blockSize > window.innerHeight) {
        setIsFullyInViewport(false)
      }
    })
    observer.observe(ref.current)

    return () => {
      observer.disconnect()
    }
  }, [ref])

  return { isFullyInViewport, setIsFullyInViewport }
}
